/** @module csi/view/customview/SaveAsController */
define([
	"dojo/_base/declare",
	"csi/action/NewController",
	"csi/locale",
	"csi/middleware/customView/customViewLeftPanel/customViewDialogLeftPanelService",
	"csi/middleware/customView/options/CustomViewOptions",
	"csi/prefs",
	"csi/xml",
	"./_DefaultControllerMixin",
	"src/c8-platform/service/customViewBuilderService",
], function(declare, NewController, locale, {validateUniqueCustomViewName}, {ShareViewWith}, csiPrefs, xml, _DefaultControllerMixin, {queryCustomViews}) {

	return declare([NewController, _DefaultControllerMixin], {
		bUpdateParent: false,
		bValidate: false,

		/** @property {CustomViewResult} availableCustomViews - available custom view for the current user */
		availableCustomViews: null,

		constructor: function() {
			this.m_typeNode = csiPrefs.TYPE_VIEW;
		},

		/**
		 * Add validation function to custom view name.
		 * @param {csi/view/Widget} view
		 */
		onCreatePopup: function(view) {
			view.defView.getField(xml.ATTR_NAME).m_onValidate = this._onValidateName.bind(this);
			this.inherited(arguments);
		},

		/**
		 * @override
		 * get the available custom views
		 */
		onPreActionDeferreds(dfds) {
			const {widget} = this;
			const {customViewContainerUrl} = this.widget;

			dfds.push(queryCustomViews(customViewContainerUrl, widget.getViewNodeType())
				.then(((results) => {
					this.availableCustomViews = results;
				}))
				.catch((error) => {
					this.error = error;
				}));
		},

		/**
		 * @override
		 * Write operations to save and select new custom view
		 */
		toWriter: function() {
			const fd = this.m_formData;
			const name = fd.getFieldValue(xml.ATTR_NAME);
			const desc = fd.getFieldValue("Description");
			const view = this.widget;
			const sourceCustomView = view.getSelectedCustomView();
			const values = view.getModifiedCustomViewValues();
			const personal = !csiPrefs.hasAdminAccess() && sourceCustomView.isShared();
			const customView = this._createCustomView(values, name, personal);
			customView.setName(name);
			customView.setDescription(desc);

			if (!csiPrefs.hasPersonalAccess()) {
				customView.sourceView = sourceCustomView.isShared() ? sourceCustomView : sourceCustomView.sourceView;
			}

			this.m_urlNode = customView.getUrl();
			this._saveCustomView(customView, true);
			this._writeDefault(this.m_urlNode);
		},

		/**
		 * @override
		 * Apply new custom view to store and view
		 */
		postProcessSuccess() {
			const {m_urlNode, widget, _changedViews} = this;

			// add the view to the store
			this._applyCustomViewChangesToStore();

			// select the new view
			widget.set("customViewDirty", false);
			widget.set("customViewApplied", _changedViews[m_urlNode]);
			widget.set("customViewId", m_urlNode);
		},

		/**
		 * Do not allow creating multiple custom views at one time.
		 * @return {boolean}
		 */
		_canRepeat: function() {
			return false;
		},

		/**
		 * Validate that given name is unique among user's personal views and any shared views.
		 * @param {View} defView
		 * @param {Field} field
		 * @param {Any} value
		 * @param {Object} params
		 * @throws {Error}
		 */
		_onValidateName: function(defView, field, value, params) {
			if (!value) {
				throw new Error(locale.resource("PreferenceNameNotUnique"));
			}

			const {availableCustomViews} = this;

			if (!validateUniqueCustomViewName(availableCustomViews, null, value, ShareViewWith.ME)) {
				throw new Error(locale.resource("PreferenceNameNotUnique"));
			}
		},
	});
});